import { deleteQbrVersion } from 'partner360/components/QBR'

export const deleteQbrDocument = (entryId: number) => deleteQbrVersion(entryId)
